import React, { useCallback, useEffect, useState } from 'react'
import useEmblaCarousel from 'embla-carousel-react'
import { Grid, Icon } from 'semantic-ui-react'

import Loading from 'components/Loading'
import CareTeamCard from './CareTeamCard'
import { getRelatedPersonId, useSearchCareTeam } from '@enlyt/base'
import { MOCK_PROVIDERS } from 'containers/Providers/mockProviders'
import useMediaQuery from 'hooks/useMediaQuery'

import styles from './styles.js'
import cssStyles from './CareTeam.module.scss'
import { useSelector } from 'react-redux'

const SLIDES_NUMBER = 3

export const CareTeam = () => {
  const { isMobile, isTablet, isSmallMonitor } = useMediaQuery()
  const [selectedSlideIndex, setSelectedSlideIndex] = useState(0)
  const patientId = useSelector(getRelatedPersonId)
  const { loading: loadingCareTeam, error: errorCareTeam } = useSearchCareTeam({
    variables: { patientId }
  })

  const visibleSlides = isSmallMonitor ? 3 : isTablet ? 3 : isMobile ? 2 : 4
  const slideBasis = `${100 / visibleSlides}%`

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: 'start',
    loop: false,
    skipSnaps: false
  })

  const scrollTo = useCallback(
    index => {
      emblaApi?.scrollTo(index, true)
    },
    [emblaApi]
  )

  useEffect(() => {
    scrollTo(selectedSlideIndex)
  }, [emblaApi, selectedSlideIndex, scrollTo])

  return (
    <Grid>
      <Grid.Column
        className={cssStyles.leftContainer}
        mobile={16}
        tablet={16}
        computer={4}
        largeScreen={4}
        widescreen={4}
        style={styles.leftContainer}
      >
        <div style={styles.iconTextContainer}>
          <Icon name='stethoscope' style={styles.icon} />
          <div style={styles.title}>My Care Team</div>
          <div style={styles.text}>View & Message your care team</div>
        </div>
      </Grid.Column>
      <Grid.Column
        className={cssStyles.rightContainer}
        mobile={16}
        tablet={16}
        computer={12}
        largeScreen={12}
        widescreen={12}
        style={styles.rightContainer}
      >
        {loadingCareTeam && <Loading />}
        {errorCareTeam && (
          <div style={styles.additionalText}>Something went wrong</div>
        )}
        {!loadingCareTeam && !errorCareTeam && MOCK_PROVIDERS.length === 0 && (
          <div style={styles.additionalText}>No Care Team Members</div>
        )}
        {!loadingCareTeam && !errorCareTeam && MOCK_PROVIDERS.length > 0 && (
          <>
            <div style={styles.carousel}>
              {MOCK_PROVIDERS.length > SLIDES_NUMBER && (
                <button
                  type='button'
                  onClick={() =>
                    setSelectedSlideIndex(Math.max(0, selectedSlideIndex - 1))
                  }
                  style={styles.button}
                  aria-label='previous'
                  disabled={selectedSlideIndex === 0}
                >
                  <Icon
                    name='chevron left'
                    color={selectedSlideIndex === 0 ? 'grey' : undefined}
                    style={styles.sliderIcon}
                  />
                </button>
              )}
              <div
                style={{ overflow: 'hidden', flex: 1, minWidth: 0 }}
                ref={emblaRef}
              >
                <div style={{ display: 'flex' }}>
                  {MOCK_PROVIDERS.map((provider, index) => (
                    <div
                      key={provider.id}
                      style={{
                        flex: `0 0 ${slideBasis}`,
                        minWidth: 0,
                        paddingRight: 8
                      }}
                    >
                      <CareTeamCard index={index} provider={provider} />
                    </div>
                  ))}
                </div>
              </div>
              {MOCK_PROVIDERS.length > SLIDES_NUMBER && (
                <button
                  type='button'
                  onClick={() =>
                    setSelectedSlideIndex(
                      Math.min(
                        selectedSlideIndex + 1,
                        MOCK_PROVIDERS.length - SLIDES_NUMBER
                      )
                    )
                  }
                  style={styles.button}
                  aria-label='next'
                  disabled={
                    selectedSlideIndex >= MOCK_PROVIDERS.length - SLIDES_NUMBER
                  }
                >
                  <Icon
                    name='chevron right'
                    color={
                      selectedSlideIndex >=
                      MOCK_PROVIDERS.length - SLIDES_NUMBER
                        ? 'grey'
                        : undefined
                    }
                    style={styles.sliderIcon}
                  />
                </button>
              )}
            </div>
          </>
        )}
      </Grid.Column>
    </Grid>
  )
}
